import { useEffect, RefObject } from 'react';

export const useScrollIntoParentIfSelected = (
  ref: RefObject<HTMLElement>,
  selected: boolean,
  offset = 5, // optional buffer/padding
  deps: any[] = []
) => {
  useEffect(() => {
    if (selected && ref.current) {
      const element = ref.current;
      const parent = element.parentElement;
      if (!parent) return;

      const rowHeight = element.offsetHeight;
      const desiredTopOffset = 2.3 * rowHeight;

      const parentRect = parent.getBoundingClientRect();
      const elementRect = element.getBoundingClientRect();

      const currentTopOffset = elementRect.top - parentRect.top;
      parent.scrollTop += currentTopOffset - desiredTopOffset;
    }
  }, [selected, ref, offset, ...deps]);
};
